import request from "./../utils/request";

export function getSiteByCustomerClientAddress(customerClientAddress) {
    return request.get(`/sites/search/customer/${customerClientAddress}`);
}


// WEBPACK FOOTER //
// ./src/api/site.js